import * as React from 'react';
import { BottomNavigationProps, BottomNavigationItem } from './types';
import styles from './BottomNavigation.module.scss';
import { useWindowSize } from '../../hooks/useWindowSize';
import { mapNavItems } from '../Navigation/utils';
import { UserSessionProvider } from '../UserSessionProvider';

import { MEDIUM_BREAKPOINT } from '../modular-grid/constants';
import { DeviceContext } from '../DeviceProvider/DeviceProvider';
import ItemGame from './Items/ItemGame';
import ItemLink from './Items/ItemLink';
import ItemCommand from './Items/ItemCommand';
import ItemDefault from './Items/ItemDefault';

const BottomNavigation: React.FC<BottomNavigationProps> = ({
  items,
  onBottomNavigationItemClick,
  onBottomNavigationGameClick,
  onBottomNavigationCommandClick,
  activeCommandItem,
  currentPagePath,
  pageTitle,
  loggedIn,
}) => {
  const { width, height } = useWindowSize();
  const { deviceType, deviceOs } = React.useContext(DeviceContext);

  const [activeCommandTitle, setActiveCommandTitle] = React.useState<string>(
    ''
  );
  const activeCommand = activeCommandItem ? activeCommandTitle : '';
  const navItems = mapNavItems(items, [currentPagePath], {
    activeCommand,
    deviceOs,
  });
  const isBottomNavHidden =
    height < 225 || width > MEDIUM_BREAKPOINT.max ? true : false;

  if (isBottomNavHidden) return null;

  const renderBottomNavigationItems = (items: BottomNavigationItem[]) =>
    items.map((item, index) => {
      if (item.url) return <ItemLink item={item} index={index} />;
      if (item.game)
        return (
          <UserSessionProvider loggedIn={loggedIn}>
            <ItemGame
              item={item}
              index={index}
              deviceType={deviceType}
              deviceOs={deviceOs}
              pageTitle={pageTitle}
              onGameClick={onBottomNavigationGameClick}
            />
          </UserSessionProvider>
        );
      if (item.command)
        return (
          <ItemCommand
            item={item}
            index={index}
            onCommandItemClick={onBottomNavigationCommandClick}
            setActiveCommandTitle={setActiveCommandTitle}
          />
        );
      return (
        <ItemDefault
          item={item}
          index={index}
          onDefaultItemClick={onBottomNavigationItemClick}
        />
      );
    });

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.slotWrapper}
        data-testid="bottom-navigation-slot-wrapper"
      >
        {renderBottomNavigationItems(navItems)}
      </div>
    </div>
  );
};

export default BottomNavigation;
